module.exports = __webpack_public_path__ + "static/media/lake.2068bc0c.jpg";